/* tslint:disable:max-line-length */
import * as React from 'react';

import { MessagingCardViewModel } from 'models';

import { UitkSheet } from 'uitk-react-sheet';

export interface MessagingSheetProps {
  messagingModel: MessagingCardViewModel;
}

export const MessagingSheet: React.FunctionComponent<MessagingSheetProps> = ({ messagingModel }) => (
  <UitkSheet
    className="uitk-flex uitk-flex-align-items-center all-x-padding-three all-y-padding-three uitk-type-300 uitk-flex-column uitk-type-center map-messaging"
    isVisible={true}
  >
    {messagingModel && messagingModel.titleModel && messagingModel.titleModel.text && (
      <span className="uitk-type-bold">{messagingModel.titleModel.text}</span>
    )}
    {messagingModel && messagingModel.subtitleModel && messagingModel.subtitleModel.text && <>{messagingModel.subtitleModel.text}</>}
  </UitkSheet>
);
